module.exports = __webpack_public_path__ + "static/media/home_bottom_image.ed9390a7.jpg";